import { FontFamily } from "@tiptap/extension-text-style"
import { Mark } from "@tiptap/react"

import { NOTEBOOK_FONTS } from "../utils/notebookCanvas"

export const NotebookFontFamily = FontFamily.extend({
  addGlobalAttributes() {
    return [
      {
        types: ["textStyle"],
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (element: HTMLElement) =>
              element.dataset.notebookFont ?? null,
            renderHTML: (attrs: Record<string, unknown>) => {
              const font = attrs.fontFamily
              if (font !== "sans" && font !== "serif" && font !== "mono") {
                return {}
              }
              return {
                "data-notebook-font": font,
                style: `font-family: ${NOTEBOOK_FONTS[font]}`,
              }
            },
          },
        },
      },
    ]
  },
})

export const NotebookHighlight = Mark.create({
  name: "highlight",
  addAttributes: () => ({
    color: {
      default: null,
      parseHTML: (element: HTMLElement) => element.getAttribute("data-color"),
      renderHTML: (attrs: Record<string, unknown>) =>
        typeof attrs.color === "string" && /^#[0-9a-f]{6}$/i.test(attrs.color)
          ? {
              "data-color": attrs.color,
              style: `background-color: ${attrs.color}`,
            }
          : {},
    },
  }),
  parseHTML: () => [{ tag: "mark" }],
  renderHTML: ({ HTMLAttributes }) => ["mark", HTMLAttributes, 0],
})
